import React, { useEffect } from 'react';

import initSwiper from '../../../components/Swiper';

export default function Usps({ swiperSlides }: { swiperSlides: string }) {
  useEffect(() => {
    initSwiper();
  }, [swiperSlides]);

  return (
    <div className="my-5.5 lg:my-10 px-2 lg:px-3.75 min-w-0 w-full">
      <div
        className="swiper-usp swiper border-y md:border-0 border-gray-950/10 text-black text-sm xl:text-base"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: swiperSlides }}
      />
    </div>
  );
}
